
export const LEAD_SOURCES = [
    { value: 'RTN', label: 'Returning customer', which: 'Name of previous client?' },
    { value: 'RWM', label: 'Referral/Word of mouth', which: 'Who gave the good word?' },
    { value: 'BBS', label: 'Billboard/Signage', which: 'Where was the sign?' },
    { value: 'ENG', label: 'Community Engagement/Event', which: 'What event?' },
    { value: 'NSP', label: 'Newspaper', which: 'Which newspaper?' },
    { value: 'PHB', label: 'Phone Book', which: 'Which phone book?' },
    { value: 'RDO', label: 'Radio', which: 'Which radio station?' },
    { value: 'TVN', label: 'Television', which: 'Which TV station?' },
    { value: 'SMP', label: 'Social Media', which: 'Which platform?' },
    { value: 'INS', label: 'Internet Search', which: 'Which search engine?' },
    { value: 'WEB', label: 'Website', which: 'Which website?' },
    { value: 'OTH', label: 'Other?' }
];